import { request, errorText, openBlob } from "../../../serviceProvider/components/accounting/api";

// /api/accounting/sales — offer number, Auftragsbestätigung, billing summary, Abschlag from progress
export const setOfferStatus = (id, status) =>
  request.post(`/sales/offers/${id}/status`, { status });
export const confirmOffer = (id, body) =>
  request.post(`/sales/offers/${id}/confirmation`, body || {});
export const confirmationPdf = id => request.blob(`/sales/offers/${id}/confirmation/pdf`);
export const emailConfirmation = (id, body) =>
  request.post(`/sales/offers/${id}/confirmation/email`, body || {});
export const billingSummary = id => request.get(`/sales/offers/${id}/billing`);
export const refreshOfferStatus = id => request.post(`/sales/offers/${id}/refresh-status`);
export const progressState = id => request.get(`/sales/offers/${id}/progress`);
export const advanceFromProgress = (id, body) =>
  request.post(`/sales/offers/${id}/progress-advance`, body);

export { errorText, openBlob };
